module.exports = "pegasus_template/assets/themelp1/product/107.png";